import { create } from 'zustand';

import { Agency } from '@/data/models/agency.interface';
import { Client } from '@/data/models/client.interface';
import { Platform } from '@/data/models/platform.interface';
import { Tenant } from '@/data/models/tenant.interface';

export interface PixidSelectionState {
  prefilledPlatform: Platform | null;
  prefilledTenant: Tenant | null;
  prefilledAgency: Agency | null;
  prefilledClient: Client | null;
  currentPlatform: Platform | null;
  currentTenant: Tenant | null;
  currentAgency: Agency | null;
  currentClient: Client | null;
  setPrefilledSelection: (
    _platform: Platform,
    _tenant: Tenant | null,
    _agency: Agency,
    _client: Client,
  ) => void;
  clearPrefilledSelection: () => void;
  setCurrentSelection: (
    _platform: Platform | null,
    _tenant: Tenant | null,
    _agency: Agency | null,
    _client: Client | null,
  ) => void;
  clearCurrentSelection: () => void;
}

const usePixidSelectionStore = create<PixidSelectionState>((set) => ({
  prefilledPlatform: null,
  prefilledTenant: null,
  prefilledAgency: null,
  prefilledClient: null,
  currentPlatform: null,
  currentTenant: null,
  currentAgency: null,
  currentClient: null,

  setPrefilledSelection: (
    platform: Platform,
    tenant: Tenant | null,
    agency: Agency,
    client: Client,
  ) => {
    set({
      prefilledPlatform: platform,
      prefilledTenant: tenant,
      prefilledAgency: agency,
      prefilledClient: client,
    });
  },

  clearPrefilledSelection: () => {
    set({
      prefilledPlatform: null,
      prefilledTenant: null,
      prefilledAgency: null,
      prefilledClient: null,
    });
  },

  setCurrentSelection: (
    platform: Platform | null,
    tenant: Tenant | null,
    agency: Agency | null,
    client: Client | null,
  ) => {
    set({
      currentPlatform: platform,
      currentTenant: tenant,
      currentAgency: agency,
      currentClient: client,
    });
  },

  clearCurrentSelection: () => {
    set({
      currentPlatform: null,
      currentTenant: null,
      currentAgency: null,
      currentClient: null,
    });
  },
}));

export default usePixidSelectionStore;
